import Vue from 'vue'

class Bus {
  constructor() {
    this.bus = new Vue()
  }
  onEditSuccess(item) {
    this.bus.$emit('edit-person', item)
  }
  editCallback(cb) {
    this.bus.$on('edit-person', cb)
  }
  onRemove(tpid) {
    this.bus.$emit('rm-person', tpid)
  }
  rmCallback(cb) {
    this.bus.$on('rm-person', cb)
  }
}
export default new Bus()
